import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import TaskDetailScreen from '@/components/TaskDetailScreen.vue';
import ReportCreationScreen from '@/components/ReportCreationScreen.vue';
import SuccessScreen from '@/components/SuccessScreen.vue';
import AdvanceScreen from "@/views/AdvancePage.vue";
import AdvanceRequestPage from "@/views/AdvanceRequestPage.vue";
import VacationView from "@/views/VacationView.vue";
import VacationRequest from "@/views/VacationRequest.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/advance',
    name: 'AdvanceScreen',
    component: AdvanceScreen,
  },
  {
    path: '/advance_request',
    name: 'AdvanceRequestPage',
    component: AdvanceRequestPage,
  },
  {
    path: '/task/:id',
    name: 'TaskDetail',
    component: TaskDetailScreen,
    props: route => ({ id: route.params.id })
  },
  {
    path: '/report/:id',
    name: 'ReportCreation',
    component: ReportCreationScreen,
    props: route => ({ id: route.params.id })
  },
  {
    path: '/success',
    name: 'Success',
    component: SuccessScreen
  },
  {
    path: '/vacation',
    name: 'VacationView',
    component: VacationView,
  },
  {
    path: '/vacation-request',
    name: 'VacationRequest',
    component: VacationRequest,
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router;
